// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 3H18V5H22V19H18V21H6V19H2V5H6V3ZM6 7H4V17H6V7ZM18 7V17H20V7H18Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-card-filled')
export default class CardFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'card-filled',
    }
  }
}
